export const PriceTypeCell = ({ value }: { value: any }) => {
    return <span>{value?.name ?? ""}</span>
}
